import supportsDateInput from "../polyfill/supportsDateInput";

require('../polyfill/customEvent')

const loadingPolyfills = [import('intersection-observer')]

if (!supportsDateInput()) {
    /*
     * Polyfill for input-type date support (Safari on macOs)
     * https://github.com/jcgertig/date-input-polyfill
     */
    loadingPolyfills.push(import('../polyfill/date-input/date-input-polyfill'))
}
if (('fetch' in window) === false) {
    loadingPolyfills.push(import('whatwg-fetch'))
}
if (('URL' in window) === false) {
    loadingPolyfills.push(import('url-polyfill'))
}
if (('Map' in window) === false) {
    loadingPolyfills.push(import('core-js/es/map'))
}
if (('forEach' in NodeList.prototype) === false) {
    loadingPolyfills.push(import('core-js/web/dom-collections'))
}
if (('startsWith' in String.prototype || 'endsWith' in String.prototype || 'includes' in String.prototype) === false) {
    loadingPolyfills.push(import('core-js/es/string'))
}
if (('includes' in Array.prototype) === false) {
    loadingPolyfills.push(import('core-js/es/array'))
}
if (('assign' in Object || 'entries' in Object || 'keys' in Object) === false) {
    loadingPolyfills.push(import('core-js/es/object'))
}
if (('closest' in Element.prototype || 'matches' in Element.prototype) === false) {
    loadingPolyfills.push(import('../polyfill/element'/* webpackChunkName: "polyfill-element" */))
}

export default Promise.all(loadingPolyfills)
